import { px } from "../utils";
export var selectColor = function selectColor(theme, colorKey) {
  return theme.color[colorKey];
};
export var selectColorOrNull = function selectColorOrNull(theme, colorKey) {
  if (colorKey === undefined) {
    return null;
  }

  var color = theme.color[colorKey];
  return color === undefined ? null : color;
};
export var selectFontFamily = function selectFontFamily(theme) {
  var fontKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  var fontFamily = theme.font[fontKey];
  return fontFamily === undefined ? null : fontFamily.family;
};

var selectFontDetails = function selectFontDetails(theme, sizeKey) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$font = _ref.font,
      font = _ref$font === void 0 ? 'primary' : _ref$font,
      _ref$breakpoint = _ref.breakpoint,
      breakpoint = _ref$breakpoint === void 0 ? 'l' : _ref$breakpoint;

  if (sizeKey === undefined) {
    return null;
  }

  return theme.font[font] !== undefined && theme.font[font].size !== undefined && theme.font[font].size[sizeKey] !== undefined && theme.font[font].size[sizeKey][breakpoint] !== undefined && theme.font[font].size[sizeKey][breakpoint] || null;
};

export var selectFontSize = function selectFontSize(theme, sizeKey) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$font = _ref2.font,
      font = _ref2$font === void 0 ? 'primary' : _ref2$font,
      _ref2$breakpoint = _ref2.breakpoint,
      breakpoint = _ref2$breakpoint === void 0 ? 'l' : _ref2$breakpoint;

  if (sizeKey === undefined) {
    return null;
  }

  var fontDetails = selectFontDetails(theme, sizeKey, {
    font: font,
    breakpoint: breakpoint
  });
  return fontDetails ? px(fontDetails.fontSize) : null;
};
export var selectLineHeight = function selectLineHeight(theme, sizeKey) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$font = _ref3.font,
      font = _ref3$font === void 0 ? 'primary' : _ref3$font,
      _ref3$breakpoint = _ref3.breakpoint,
      breakpoint = _ref3$breakpoint === void 0 ? 'l' : _ref3$breakpoint;

  if (sizeKey === undefined) {
    return null;
  }

  var fontDetails = selectFontDetails(theme, sizeKey, {
    font: font,
    breakpoint: breakpoint
  });
  return fontDetails ? fontDetails.lineHeight : null;
};
export var selectFontWeight = function selectFontWeight(theme, fontWeightKey) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref4$font = _ref4.font,
      font = _ref4$font === void 0 ? 'primary' : _ref4$font;

  if (fontWeightKey === undefined) {
    return null;
  }

  return theme.font[font] !== undefined && theme.font[font].fontWeight !== undefined && theme.font[font].fontWeight[fontWeightKey] !== undefined && theme.font[font].fontWeight[fontWeightKey] || null;
};
export var selectSpace = function selectSpace(theme, sizeName) {
  if (sizeName === undefined) {
    return null;
  }

  var space = theme.space[sizeName];
  return space === undefined ? null : space;
};
export var selectConstant = function selectConstant(theme, constantName) {
  return theme.constants[constantName];
};
export var selectBreakpoint = function selectBreakpoint(theme, sizeName) {
  if (sizeName === undefined) {
    return null;
  }

  return theme.breakpoint[sizeName] || null;
};
export var selectZIndex = function selectZIndex(theme, componentName) {
  if (componentName === undefined) {
    return null;
  }

  var zIndex = theme.zIndex[componentName];
  return zIndex === undefined ? null : zIndex;
};